export enum CartStep {
  TestsAvailable,
  ShoppingCart,
  PanelDetails,
  Consent,
  PaymentAddress,
  Payment,
  PaymentSuccess,
  PaymentProblem,
  Unknown,
}
